import { useQuery, UseQueryResult } from 'react-query';
import { Note } from 'types';
import { client } from 'utils/api-client';

function useNote(noteId: string | undefined): UseQueryResult<{ data: Note }> {
  return useQuery(['notes', noteId], () => client.get(`notes/${noteId}/`), {
    enabled: !!noteId,
  });
}

export default useNote;
